module.exports = __webpack_public_path__ + "static/media/Celeb5.14eaa6bb.jpg";